import axios from "axios";
import { dedupeRegisteredUsersForDisplay } from "../utils/occurrenceParticipantUtils";

export async function fetchEventByOccurrenceId(occurrenceId) {
  const response = await axios.post(
    "/api/admin/retrieve-event-by-id",
    { occurrenceId },
    { withCredentials: true }
  );
  return response.data;
}

export async function fetchOrgDivisions(organizationId) {
  const response = await axios.post(
    "/api/admin/post-org-structure",
    { organizationId },
    { withCredentials: true }
  );
  const divisions = response.data?.divisions || [];
  return divisions.map((division) => ({
    id: division.id,
    parentId: division.parentId,
    divisionFullName: division.divisionFullName,
    status: division.status,
  }));
}

export async function fetchEventUsersByStatus(eventOccurrenceId, useParticipants = false) {
  const endpoint = useParticipants ? "/api/user/retrieve-participants" : "/api/user/retrieve-registers";
  const response = await axios.post(endpoint, { eventOccurrenceId }, { withCredentials: true });
  const rows = response.data || [];
  return useParticipants ? dedupeRegisteredUsersForDisplay(rows) : rows;
}

export async function fetchEventPlannerParticipants(eventOccurrenceId) {
  const response = await axios.post(
    "/api/user/retrieve-event-planner-participants",
    { eventOccurrenceId },
    { withCredentials: true }
  );
  return response.data || { participants: [] };
}

export async function fetchEventPlannerFleet(eventOccurrenceId) {
  const response = await axios.post(
    "/api/user/retrieve-event-planner-fleet",
    { eventOccurrenceId },
    { withCredentials: true }
  );
  return response.data || { vehicles: [], crewTemplates: [], teamNamesByGroup: {} };
}

